module.exports = "<ng-content></ng-content>";